import { ThisGorillaUtils } from "@thisgorilla/primate-ds";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import styled from "styled-components";

import { API_CALLS } from "../../../API/api_calls";
import { useAppSelector } from "../../../redux";
import { ArticleCard } from "../../Common";

export const ArticlePreview = () => {
  const params = useParams();
  const article_id = params?.id ?? "";
  const { draftArticle } = useAppSelector((state) => state.article);

  useEffect(() => {
    API_CALLS.ARTICLE.getASingleArticleDraft(article_id);
  }, [article_id]);

  if (article_id !== draftArticle.post_id) return <>Loading...</>;

  return (
    <Wrapper>
      <Container>
        <ArticleCard article={draftArticle} />
      </Container>
    </Wrapper>
  );
};

const Container = styled.div`
  max-width: ${ThisGorillaUtils.convertPxToRem("974")}rem;
  padding: ${({ theme }) => theme.spacing["spacing-4"].value}rem
    ${({ theme }) => theme.spacing["spacing-none"].value}rem;
  margin: auto;
  min-height: calc(100vh - 72px);
`;

const Wrapper = styled.div`
  background: ${({ theme }) =>
    theme.Color.elevation.surface["surface-primary"].value};
`;
